import { render } from "./TheFooter.vue?vue&type=template&id=797b5bed&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=797b5bed&scoped=true&lang=css"

import exportComponent from "D:\\Learning\\Projects\\allankirui.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797b5bed"]])

export default __exports__